import styled from "styled-components";

const AdminEmployeeSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;

  .second-navbar {
    width: 100vw;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    gap: 3px;
    padding: 5px;
  }
  .office-button {
    width: 10%;
  }
  .add-employee {
    width: 20%;
  }
  .employee-directory-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 15px;
  }
  .user-card {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    flex-wrap: wrap;
    gap: 5px;
  }
`;

export default AdminEmployeeSc;
